document.addEventListener("DOMContentLoaded", function () {
  const sectionSelector = "#shopify-section-template--19486181720195__17564494642f9e7384>.section>.custom-section-content>.section-content-wrapper";

  const btn1 = document.querySelector(
    ".button-secondary--AZ0VVM09Rb2ErcWVrS__button_Bx9kRm"
  );
  const btn2 = document.querySelector(
    ".button-secondary--AY1Fma1BKVjZQTUorR__button_8zxJwb"
  );

  const blockLast = document.querySelector(
    `${sectionSelector} > .group-block:last-child`
  );
  const blockSecond = document.querySelector(
    `${sectionSelector} > .group-block:nth-child(2)`
  );

  // Hide last block on load and set first button active
  if (blockLast) blockLast.classList.add("hidden");
  if (btn1) btn1.classList.add("tab-active");

  function activateTab(activeBtn, inactiveBtn, hideBlock, showBlock) {
    hideBlock.classList.add("hidden");
    showBlock.classList.remove("hidden");

    activeBtn.classList.add("tab-active");
    if (inactiveBtn) inactiveBtn.classList.remove("tab-active");
  }

  if (btn1 && blockLast && blockSecond) {
    btn1.addEventListener("click", function () {
      activateTab(btn1, btn2, blockLast, blockSecond);
    });
  }

  if (btn2 && blockLast && blockSecond) {
    btn2.addEventListener("click", function () {
      activateTab(btn2, btn1, blockSecond, blockLast);
    });
  }



  
});
